import { Component, computed, input, output } from '@angular/core';

import { PackageUserWithDisplayName } from 'src/app/features/package-users/util';

import { isParticipantCheckedIn, showsContinueButton } from './participant-card.util';

@Component({
  selector: 'app-participant-card',
  templateUrl: './participant-card.component.html',
  styleUrls: ['./participant-card.component.scss'],
  standalone: false,
})
export class ParticipantCardComponent {
  participant = input.required<PackageUserWithDisplayName>();
  associatedUsers = input.required<string[]>();
  usersInWaitingRoom = input.required<string[]>();
  joinSession = output<string>();

  isAssociated = computed(() => {
    return !!this.participant() && this.associatedUsers()?.includes(this.participant().packageUserGuid);
  });

  isInWaitingRoom = computed(() => {
    return !!this.participant() && this.usersInWaitingRoom()?.includes(this.participant().packageUserGuid);
  });

  isLoading = computed(() => {
    return !this.participant()?.checkInStatus;
  });

  isCheckedIn = computed(() => isParticipantCheckedIn(this.participant()));

  displayName = computed(() => {
    return this.participant()?.displayName;
  });

  statusBadgeText = computed(() => {
    if (this.isAssociated() || this.isInWaitingRoom()) return 'Ready';
    if (this.isCheckedIn()) return 'Awaiting';
    return 'Not started';
  });

  statusBadgeClass = computed(() => {
    if (this.isAssociated() || this.isInWaitingRoom()) return 'ready';
    if (this.isCheckedIn()) return 'awaiting';
    return 'not-started';
  });

  instructionText = computed(() => {
    if (this.isAssociated()) return 'Ready to join';
    if (this.isInWaitingRoom()) return 'Confirm your identity to transfer your session to this device';
    if (this.isCheckedIn()) return 'Confirm your identity to join the session';
    return 'Completing non-notarized signing steps';
  });

  showContinueButton = computed(() =>
    showsContinueButton(this.participant(), this.associatedUsers())
  );

  onJoinSession(): void {
    this.joinSession.emit(this.participant().packageUserGuid);
  }
}
